// import { Controller } from "@hotwired/stimulus"
import Dropdown from "@stimulus-components/dropdown"

// Connects to data-controller="dropdown"
export default Dropdown
